import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Zap, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/fbPixel';
export function FinalCTA() {
  return <section className="py-24 bg-[#0D3B12] relative overflow-hidden" data-id="element-48">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-49">
        <div className="absolute -top-40 -left-40 w-96 h-96 rounded-full bg-[#4CAF50] blur-3xl" data-id="element-50"></div>
        <div className="absolute bottom-0 right-0 w-full h-1/2 bg-gradient-to-t from-black/60 to-transparent" data-id="element-51"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-53">
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-54">
            ¿Listo Para Sentirte Bien Desde Adentro?
          </h2>

          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto" data-id="element-55">
            Únete a miles de familias latinas en USA que ya transformaron su
            bienestar con el poder natural del Amazonas.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-10" data-id="element-56">
            <a href="https://elixirx.site/cart/43924707016838:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Kit Inicio', 97)} className="w-full md:w-auto bg-transparent border-2 border-white/20 hover:bg-white/10 text-white text-lg px-8 py-4 rounded-full font-bold transition-all" data-id="element-57">
              Kit Inicio - $97 + $12 envío
            </a>
            <a href="https://elixirx.site/cart/43924713701510:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Gut Rest Program', 141)} className="w-full md:w-auto bg-[#4CAF50] hover:bg-[#1B5E20] text-white text-lg px-10 py-4 rounded-full font-bold transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1 border-2 border-[#4CAF50]" data-id="element-58">
              ⭐ Gut Rest Program - $141{' '}
              <span className="text-xs ml-1 bg-white/20 px-2 py-1 rounded" data-id="element-59">
                ENVÍO GRATIS
              </span>
            </a>
            <a href="https://elixirx.site/cart/43924738179206:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart('Advanced Gut + Recovery System', 189.5)} className="w-full md:w-auto bg-[#F9A825] hover:bg-[#FDD835] text-[#1A1A1A] text-lg px-8 py-4 rounded-full font-bold transition-all shadow-lg" data-id="element-60">
              👑 Sistema Completo - $189.50
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-gray-300 mb-12" data-id="element-61">
            <div className="flex items-center" data-id="element-62">
              <Zap size={16} className="text-[#F9A825] mr-2" data-id="element-63" /> Stock limitado
            </div>
            <div className="flex items-center" data-id="element-64">
              <span className="mr-2" data-id="element-65">⏱️</span> Pedidos procesan en 24 horas
            </div>
            <div className="flex items-center" data-id="element-66">
              <ShieldCheck size={16} className="text-[#4CAF50] mr-2" data-id="element-67" /> Pago
              100% Seguro
            </div>
          </div>

          <a href="https://wa.link/zcnuqo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center text-white hover:text-[#4CAF50] transition-colors font-medium border-b border-transparent hover:border-[#4CAF50] pb-1" data-id="element-68">
            <MessageCircle size={20} className="mr-2" data-id="element-69" />
            💬 ¿Tienes preguntas? Escríbenos
          </a>
        </motion.div>
      </div>
    </section>;
}